<script>
  import Page from '@components/page'
  import Block from '@components/general/block'
  import { Settings } from 'lucide-svelte'

  let title = 'Settings'
  let description = 'Manage your settings'
</script>

<Page.Layout title={title}>

  <Page.Navigation title={title} Icon={Settings} />

  <Page.Titles title={title} subtitle={description} />

  <Page.Content>

    {#snippet main()}
      <Block.Element title="Platform Settings">
        
      </Block.Element>
    {/snippet}

    {#snippet aside()}
      <Block.Element title="Quick links">
        
      </Block.Element>
    {/snippet}

  </Page.Content>
  
</Page.Layout>